import MuiList, { type ListProps as MuiListProps } from '@mui/material/List';
import ListItem, { ListItemProps } from './ListItem';

export { ListItem, type ListItemProps };

export type ListProps = MuiListProps;

export default function List(props: ListProps) {
  return <MuiList {...props} />;
}
